import { CspConfig } from 'data/cspConfig/cspConfig.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getCspConfigDataToSubmit(
  cspConfig: CspConfig,
  originalCspConfig: CspConfig | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<CspConfig> {
  const cspConfigBody: WithAuditDetails<CspConfig> = {
    data: cspConfig,
  };

  let actionType = AuditActionType.CSP_CONFIG_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.CSP_CONFIG_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(cspConfig, null, isEdit, originalCspConfig),
      cspConfig.name,
      AuditService.CSP_CONFIG,
      actionType,
    );
    cspConfigBody.auditDetails = auditDetails as AuditDetails;
  }

  return cspConfigBody;
}
